export function toErrorMessage(error: unknown, fallback = 'An unexpected error occurred'): string {
  if (typeof error === 'string') {
    const trimmed = error.trim();
    return trimmed.length > 0 ? trimmed : fallback;
  }

  if (error instanceof Error) {
    return error.message?.trim() || fallback;
  }

  if (error && typeof error === 'object') {
    const maybeError = error as {
      message?: unknown;
      detail?: unknown;
      error?: unknown;
      type?: unknown;
    };

    if (typeof maybeError.message === 'string' && maybeError.message.trim().length > 0) {
      return maybeError.message;
    }

    if (typeof maybeError.detail === 'string' && maybeError.detail.trim().length > 0) {
      return maybeError.detail;
    }

    if (maybeError.error !== undefined) {
      return toErrorMessage(maybeError.error, fallback);
    }

    try {
      const serialized = JSON.stringify(error);
      return serialized && serialized !== '{}' ? serialized : fallback;
    } catch {
      return fallback;
    }
  }

  if (error == null) {
    return fallback;
  }

  return String(error);
}
